// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// 完整引入Element
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import ElementPlus from 'element-plus'
// import 'element-plus/lib/theme-chalk/index.css'
import axios from 'axios'
import Common from './components/Common'
Vue.prototype.$axios = axios
Vue.prototype.$Common = Common
Vue.use(ElementUI)
// Vue.use(ElementPlus)

// 加上token
// 在请求头中加token
Vue.config.productionTip = false
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('Authorization')) {
      config.headers.Authorization = localStorage.getItem('Authorization')
      config.headers.token = localStorage.getItem('Authorization')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js